import styled, { css, keyframes } from "styled-components";
import { getColor, StyleVars, Fonts, typeScale } from "core/utils";
import { align, resetBtn, size } from "styled-manila";
import { Content, SectionSubtitle } from "core/styles";
import { LinkOut } from "../../styles";

export const Slider = styled.div`
	position: relative;
	display: block;
	color: inherit;
	text-decoration: none;
	z-index: 2;
	overflow: hidden;
	border-radius: ${typeScale(2)};
	box-shadow: 0 20px 35px 0 rgba(74,74,74,0.20);

	@media (max-width: ${StyleVars.screenSm}) {
		height: 100%;
	}
`;

export const MobileCircleWrapper = styled.div`
	display: flex;
	justify-content: center;
	padding: ${typeScale(2)} 0;
`;

export const Circle = styled.div`
	height: ${typeScale(1)};
	width: ${typeScale(1)};
	border-radius: 50%;
	margin: ${typeScale(0.5)};
	background-color: ${props => props.active ? getColor("gray") : getColor("gray3")};
	transition: transform 0.3s;
	transform-origin: center;
	${({ active }) => active && css`
		transform: scale(1.25, 1.25);
	`}
`;

export const SliderWrapper = styled.div`
	position: relative;
`;

export const CenteredButton = styled.button`
	${resetBtn};
	${align("vertical")};
	z-index: 2;
	transition: 0.3s;

	&:hover,
	&:active {
		[fill]: {
			fill: ${getColor("primaryBrandHover")};
		}
	}

	span {
		display: none;
	}

	svg {
		max-width: 70%;

		@media (min-width: 1310px) {
			max-width: 100%;
		}
	}
`;

export const PrevBtn = styled(CenteredButton)`
	z-index: 5;
	left: 16px;
	svg {
		transform: rotate(180deg);
	}
	@media (min-width: 1310px) {
		left: -52px;
	}
`;

export const NextBtn = styled(CenteredButton)`
	right: 16px;

	@media (min-width: 1310px) {
		right: -52px;
	}
`;
